'use client'
import {
	HDSPlusButton,
	type HDSPlusButtonProps,
} from '@hashicorp/react-mds/src/hds-plus/button'
import { useApplicationForm } from 'lib/careers/context'

type ApplyButtonProps = Omit<HDSPlusButtonProps, 'onClick' | 'text' | 'size'>

export default function ApplyButton({ className, ...props }: ApplyButtonProps) {
	const { showApplication } = useApplicationForm()

	return (
		<HDSPlusButton
			onClick={showApplication}
			text="Apply"
			size="large"
			className={className}
			{...props}
		/>
	)
}
